export const isDefined = <T>(value: T | undefined): value is Exclude<T, undefined> => value !== undefined;
export const isNotNull = <T>(value: T | null): value is Exclude<T, null> => value !== null;
export const isNotNullDefined = <T>(value: T | null | undefined): value is Exclude<T, null | undefined> =>
    isDefined(value) && isNotNull(value);
